// extracted by mini-css-extract-plugin
export default {"progress":"progress--r_3uT","warning":"warning--tusz7","overdue":"overdue--NrrFR","icon":"icon--hJZzZ","title":"title--jyuLa"};